import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ubi-title',
  imports: [],
  templateUrl: './title.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './title.component.scss',
})
export class TitleComponent {
  @Input() level: 1 | 2 | 3 | 4 = 1;

  @HostBinding('class') get levelClass() {
    return `title--${this.level}`;
  }
}
